/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import { useCallback, useMemo, useRef, useState } from 'react';
import slugify from 'slugify';

import useGameState from '../../hooks/useGameState';

import Keyboard from '../partials/Keyboard';
import { GameApi } from './Base';
import QuestionsGame from './Questions';

import styles from '../../../styles/games/hangman.module.css';

interface HangmanGameProps {
    className?: string;
    game: HangmanGame;
    canPlay: boolean;
    reload: () => void;
    participation: Participation;
}

function HangmanGame({ className = null, game, participation, ...props }: HangmanGameProps) {
    const { currentQuestion, currentAnswer } = useGameState(game, participation);

    const [loading, setLoading] = useState(false);

    const { id: questionId, body: questionBody = null } = currentQuestion || {};
    const { value: letters = [] } = currentAnswer || {};

    const userLetters = useMemo(() => {
        const body = slugify(questionBody).toLowerCase();
        return (letters || []).map((letter) => ({
            value: letter,
            valid: body.indexOf(slugify(letter)) !== -1,
        }));
    }, [letters, questionBody]);

    const apiRef = useRef<GameApi>(null);

    const onClickLetter = useCallback(
        (letter) => {
            const { answerQuestion } = apiRef.current;
            const newLetters = [...letters, letter];
            answerQuestion(questionId, newLetters);
        },
        [letters, questionId],
    );

    return (
        <QuestionsGame
            game={game}
            participation={participation}
            {...props}
            apiRef={apiRef}
            onLoadingChange={setLoading}
            className={classNames([styles.container, className])}
        >
            <Keyboard
                onClick={onClickLetter}
                activeLetters={userLetters}
                loading={loading}
                className={styles.keyboard}
            />
        </QuestionsGame>
    );
}

export default HangmanGame;
